import { delay } from '@/hooks/LitSessionContext/useLitAuth';
type HomePageProps = {
  userName: string;
};
type HomePageRef = React.ForwardedRef<HTMLDivElement>;
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
// import { LogToMixpanel } from '@/lib/mixpanel';
import HomeController from '@/components/explore/HomeController';
import { useLocalStorage } from 'usehooks-ts';
import useERC20Balance from '@/hooks/portfolio/useERC20Balance';
import { useSession } from '@/contexts/LitSessionProvider';
import { GeniusDB } from '@/core/db-connection';
import { Knex } from 'knex';
import { ExtendedDbCloudWalletUserInfo } from '@shared/types/db/user';
import detectDeviceFromUserAgent from '@/lib/misc/detectUserAgent';
export async function getServerSideProps(context) {
  const {
    query,
    res
  } = context;
  const code = query.code;
  const db: Knex = GeniusDB();
  if (code) {
    //eth_address is uppercase in referral table and lowercase in cloudwallets table lol
    const referringUser = await db('referral_codes').select('*').where('referral_code', code).first();
    const ethAddress = referringUser?.eth_address;
    const cloudWallet = await db('cloud_wallets').select('*').whereRaw('LOWER(eth_address) = ?', [ethAddress.toLowerCase()]).first();
    const userName = cloudWallet?.username;
    console.log('userNameelwkfjw', userName);
    return {
      props: {
        userName
      }
    };
  } else {
    return {
      props: {
        userName: ''
      }
    };
  }
}
export default function HomePage(props: HomePageProps, ref: HomePageRef) {
  const router = useRouter();
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const [referralUrlCode, setReferralUrlCode] = useLocalStorage('referral-code', '');
  const [isAppleNativeApp, setIsAppleNativeApp] = useLocalStorage('isAppleNativeApp', false);
  const [isNativeApp, setIsNativeApp] = useLocalStorage('isNativeApp', false);
  const [isGoogleNativeApp, setIsGoogleNativeApp] = useLocalStorage('isGoogleNativeApp', false);

  //preloading balances
  const {
    PKP
  } = useSession();
  const {
    data: assetData,
    isLoading: loadingBalances
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress]
  });
  useEffect(() => {
    async function replaceUrl(urlParams: URLSearchParams) {
      await delay(1000);
      urlParams.delete('message');
      urlParams.delete('removePWA');
      urlParams.delete('disableRef');
      urlParams.delete('disableSwap');
      urlParams.delete('code');
      const newUrl = `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`;
      window.history.replaceState({}, '', newUrl);
    }
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    const message = urlParams.get('message');
    const removePWA = urlParams.get('removePWA');
    // const disableRef = urlParams.get('disableRef');
    // const disableSwap = urlParams.get('disableSwap');
    const code = urlParams.get('code');
    if (removePWA) {
      setIsNativeApp(true);
      localStorage.setItem('removePWA', 'true');
      const onIPhone = navigator?.userAgent?.includes('iPhone');
      if (onIPhone) {
        setIsAppleNativeApp(true);
      } else {
        setIsGoogleNativeApp(true);
      }
    }
    // if (disableRef) {
    //   localStorage.setItem('disableRef', 'true');
    // }
    // if (disableSwap) {
    //   localStorage.setItem('disableSwap', 'true');
    // }
    if (code) {
      setReferralUrlCode(code);
    }
    console.log('message', message);
    if (message || removePWA || code) {
      message && setToastMessage(message);
      replaceUrl(urlParams);
    }
  }, [router]);
  useEffect(() => {
    if (toastMessage) {
      toast(toastMessage, {
        duration: 5000
      });
    }
  }, [toastMessage]);
  return <HomeController userName={props?.userName} data-sentry-element="HomeController" data-sentry-component="HomePage" data-sentry-source-file="index.tsx" />;
}